import React from 'react';
import { Section } from './Section';
import { CheckCircle2 } from 'lucide-react';
export function IdentificationSection() {
  const bullets = ['amaneces con el abdomen inflamado', 'retienes líquidos fácilmente', 'te sientes pesada durante el día', 'tu ropa a veces se siente más apretada', 'ya intentaste "comer mejor" pero sigues hinchada', 'quieres algo rápido, simple y realista'];
  return <Section className="bg-sage" data-id="element-290">
      <div className="max-w-3xl mx-auto" data-id="element-291">
        <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-8 text-center" data-id="element-292">
          Si te sientes hinchada, pesada o incómoda con tu abdomen, esta guía es
          para ti
        </h2>

        <div className="bg-cream p-8 rounded-2xl border border-cream-dark" data-id="element-293">
          <ul className="space-y-4" data-id="element-294">
            {bullets.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-295">
                <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-296" />
                <span className="text-gray-800 text-lg" data-id="element-297">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}